import { useCallback } from 'react';
import Axios, { type AxiosRequestConfig } from 'axios';
import { authClient } from '@/auth';

export const AXIOS_INSTANCE = Axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

/**
 * Orval mutator. Forwards the player JWT from `authClient.getAuthHeaders()`
 * on every request so the generated React Query hooks reach authenticated
 * endpoints automatically. The baseURL must match the host the auth client
 * logs into (configured in `@/auth`) — otherwise the JWT issued by one
 * server won't validate against the other and every request returns 401.
 *
 * The returned callback is `useCallback`-stable so the `useCallback` Orval
 * wraps around each generated request stays referentially stable too —
 * otherwise consumers' `useEffect` deps that include the generated function
 * (e.g. `useDepositControllerCreateSessionHook`) would re-run on every
 * render.
 */
export const useCustomInstance = <T>(): ((config: AxiosRequestConfig) => Promise<T>) => {
  return useCallback((config: AxiosRequestConfig) => {
    const authHeaders = authClient.getAuthHeaders();
    return AXIOS_INSTANCE({
      ...config,
      baseURL: import.meta.env.VITE_API_URL,
      // baseURL: 'https://predictions-api.local.crowncoinscasino.com',
      headers: { ...authHeaders, ...config.headers },
    }).then(({ data }) => data);
  }, []);
};

export default useCustomInstance;
